<div class="page-container p-0 m-0">
  <!-- <div *ngIf="showSplashScreen" class="overflow-hidden overflow-y-hidden">
    <app-splash-screen></app-splash-screen>
  </div> -->

  <div
    *ngIf="!showSplashScreen"
    class="content-wrap"
    [class.content-wrap--sticky-footer]="shouldStickFooter()"
  >
    <app-header
      *ngIf="shouldshowheader()"
      (openChatFromHeader)="openChatHandler()"
    ></app-header>

    <!-- <div *ngIf="isShowBonusBanner()" class="bonus-banner-container">
      <div class="bonus-scroll-container">
        <div class="bonus-scroll-content flex items-center space-x-12 font-bold">
          <div class="flex items-center gap-2 whitespace-nowrap">
            <span class="text-[#7DE7E5]">
              💰 {{ signupBonus > 0 ? signupBonus + "%" : "HUGE" }} SIGNUP BONUS
            </span>
            <span class="text-white">ON YOUR FIRST DEPOSIT!</span>
          </div>
          <div class="flex items-center gap-2 whitespace-nowrap">
            <span class="text-[#7DE7E5]">🔥 SIGN UP NOW</span>
            <span class="text-white">TO CLAIM YOUR EXCLUSIVE BONUS!</span>
          </div>
          <div class="flex items-center gap-2 whitespace-nowrap">
            <span class="text-[#7DE7E5]">💎 LIMITED TIME OFFER</span>
            <span class="text-white">DON'T MISS OUT!</span>
          </div>
          
          <div class="flex items-center gap-2 whitespace-nowrap">
            <span class="text-[#7DE7E5]">
              💰 {{ signupBonus > 0 ? signupBonus + "%" : "HUGE" }} SIGNUP BONUS
            </span>
            <span class="text-white">ON YOUR FIRST DEPOSIT!</span>
          </div>
          <div class="flex items-center gap-2 whitespace-nowrap">
            <span class="text-[#7DE7E5]">🔥 SIGN UP NOW</span>
            <span class="text-white">TO CLAIM YOUR EXCLUSIVE BONUS!</span>
          </div>
          <div class="flex items-center gap-2 whitespace-nowrap">
            <span class="text-[#7DE7E5]">💎 LIMITED TIME OFFER</span>
            <span class="text-white">DON'T MISS OUT!</span>
          </div>
        </div>
      </div>
    </div> -->
    <div *ngIf="addBalance">
      <app-add-wallet [showModal]="addBalance"></app-add-wallet>
    </div>
    <router-outlet></router-outlet>

    <div *ngIf="shouldShowChat()" class="fixed bottom-4 right-4 z-[999]">
      <button
        class="bg-gradient-to-r from-[#f5cf6b] to-[#e7b53f] rounded-full p-4 shadow-lg hidden md:block relative"
        (click)="toggleChat()"
      >
        <!-- Black SVG chat bubble -->
        <svg
          width="22"
          height="22"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
        >
          <path
            stroke="#000"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
          />
        </svg>
      </button>

      <app-chat *ngIf="isChatOpen"></app-chat>
    </div>

    <!-- <div *ngIf="isBonusButton()" class="fixed top-36 right-4 z-[999]">
      <button
        class="bonus-floating-btn animate-bounce-slow"
        (click)="redirectToSignup()"
      >
        <div class="flex items-center gap-2 px-4 py-3">
          <span class="text-2xl">🎁</span>
          <div class="flex flex-col items-start">
            <span class="text-[10px] uppercase tracking-wider text-white/70"
              >Limited Offer</span
            >
            <span class="text-sm font-bold text-white whitespace-nowrap">
              Avail {{ signupBonus > 0 ? signupBonus + "%" : "HUGE" }} Signup
              Bonus
            </span>
          </div>
        </div>
      </button>
    </div> -->

    <!-- Floating Install App Button (mirrors bonus button, left side) -->
    <!-- <div 
    *ngIf="
        showInstallFloating && shouldShowInstallButton() && shouldShowChat()
      " class="fixed top-[59%] left-4 z-[999] absuolute">
      
      <span class="close-btn" (click)="showInstallFloating = false">✕</span>
      <button class="bonus-floating-btn animate-bounce-slow" (click)="installFloating()">
        <div class="flex items-center gap-2 px-4 py-3">
          <div class="flex flex-col items-start">
            <span class="text-[10px] uppercase tracking-wider text-white/70">Free &amp; Fast</span>
            <span class="text-sm font-bold text-white whitespace-nowrap">
              Install App
            </span>
          </div>
        </div>
      </button>
    </div>  -->
    <div
      *ngIf="
        showInstallFloating && shouldShowInstallButton() && shouldShowChat()
      "
      class="fixed bottom-4 left-4 right-4 max-w-[440px] mx-auto z-[19999901] bg-[rgb(12,18,31)] border border-[rgb(30,42,61)] rounded-[14px] px-4 py-3 shadow-[0_8px_28px_rgba(0,0,0,0.55)] flex items-center gap-3 animate-slideUp font-jakarta"
    >
      <!-- Logo -->
      <img src="icon-72x72.png" class="w-10 h-10 rounded" />

      <!-- Text -->
      <div class="flex-1 font-jakarta">
        <div class="text-white font-bold text-[14px]">Install Casinoze</div>
        <div class="text-sm text-slate-100">
          Add to home screen for the best experience
        </div>
      </div>

      <!-- Install Button -->
      <button
        class="bg-gradient-to-r from-[#f5cf6b] to-[#e7b53f] text-[#0a0f1d] px-[18px] py-[9px] rounded-full text-[13px] font-bold cursor-pointer whitespace-nowrap border-none"
        (click)="installFloating()"
      >
        Install
      </button>

      <!-- Close Button -->
      <button
        class="bg-none border-none text-gray-400 hover:text-white text-[22px] cursor-pointer px-[6px] py-[2px] leading-none"
        (click)="showInstallFloating = false"
      >
        ✕
      </button>
    </div>

    <app-footer
      *ngIf="shouldshowheader()"
      [chatUnreadCount]="unreadCounts"
    ></app-footer>
    <!-- Fixed Cartoon Character -->
    <!-- <img *ngIf="showCharacterImage" src="https://cmax.pages.dev/assets/FixedCartoonCharacter.png" alt="Character"
    class="fixed-character" /> -->
  </div>

  <!-- <app-coming-soon></app-coming-soon> -->

  <app-user-manual></app-user-manual>
  <app-common-modal></app-common-modal>
</div>
